import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

const STATUS_COLORS = {
    operational: "bg-emerald-500 hover:bg-emerald-400",
    degraded: "bg-amber-500 hover:bg-amber-400",
    outage: "bg-red-500 hover:bg-red-400",
};

function UptimeBar({ history }) {
    const { t } = useTranslation();

    const uptimePercent = useMemo(() => {
        if (!history || history.length === 0) return 100;
        const operational = history.filter((d) => d.status === "operational").length;
        return ((operational / history.length) * 100).toFixed(2);
    }, [history]);

    if (!history || history.length === 0) {
        return (
            <div className="text-center py-8 text-gray-400 text-sm">
                {t("statusPage.noHistory")}
            </div>
        );
    }

    return (
        <div className="space-y-3">
            <div className="flex items-center justify-between">
                <h3 className="text-sm font-medium text-gray-700">
                    {t("statusPage.uptimeTitle")}
                </h3>
                <span className="text-sm font-semibold text-emerald-600">
                    {uptimePercent}% {t("statusPage.uptime")}
                </span>
            </div>
            <div className="flex gap-[2px] h-8 items-end">
                {history.map((day) => (
                    <div
                        key={day.date}
                        className={`flex-1 rounded-sm min-w-[3px] h-full transition-colors duration-100 ${STATUS_COLORS[day.status] || STATUS_COLORS.operational}`}
                        title={`${day.date}: ${t(`statusPage.status.${day.status}`)}`}
                    />
                ))}
            </div>
            <div className="flex justify-between text-xs text-gray-400">
                <span>{t("statusPage.daysAgo", { count: history.length })}</span>
                <span>{t("statusPage.today")}</span>
            </div>
        </div>
    );
}

export default UptimeBar;
